import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IFetchExpressPaymentMethodsResponse,
  IExpressPaymentMethods,
} from '@wix/cashier-core/dist/src/services/PaymentMethod/types';

export const loadPaymentMethods = createAsyncThunk(
  'LOAD_PAYMENT_METHODS',
  (paymentMethodsPromise: Promise<IFetchExpressPaymentMethodsResponse>): Promise<IExpressPaymentMethods> => {
    return paymentMethodsPromise.then((r) => r.paymentMethods);
  },
);
